module.exports = __webpack_public_path__ + "static/img/91BM-047-ClarenceHung.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-047-ClarenceHung.jpg
// module id = ErcZ
// module chunks = 0